export default "__VITE_ASSET__XuGVUdk3__"